export default __webpack_public_path__ + "static/media/0042.3c9c1ada.jpg";